module.exports = __webpack_public_path__ + "img/share-line.a9e4936e.svg";